var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sys-edit" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formSys",
            attrs: {
              "label-position": "top",
              model: _vm.formSys,
              rules: _vm.rules,
              "label-width": "140px"
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "路由编号", prop: "routeId" } },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入路由编号" },
                  model: {
                    value: _vm.formSys.routeId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formSys,
                        "routeId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formSys.routeId"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "路由路径", prop: "routeUri" } },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入路由路径" },
                  model: {
                    value: _vm.formSys.routeUri,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formSys,
                        "routeUri",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formSys.routeUri"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "系统名称", prop: "systemId" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", placeholder: "请选择系统名称" },
                    model: {
                      value: _vm.formSys.systemId,
                      callback: function($$v) {
                        _vm.$set(_vm.formSys, "systemId", $$v)
                      },
                      expression: "formSys.systemId"
                    }
                  },
                  _vm._l(_vm.systemlist, function(option, i) {
                    return _c("el-option", {
                      key: i,
                      attrs: {
                        label: option.systemName,
                        value: option.systemId
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "执行顺序", prop: "routeOrder" } },
              [
                _c("el-input-number", {
                  staticStyle: { width: "100%", "text-align": "left" },
                  attrs: {
                    "auto-complete": "off",
                    precision: 0,
                    controls: false,
                    placeholder: "请输入路由执行顺序"
                  },
                  model: {
                    value: _vm.formSys.routeOrder,
                    callback: function($$v) {
                      _vm.$set(_vm.formSys, "routeOrder", $$v)
                    },
                    expression: "formSys.routeOrder"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "过滤器字符", prop: "filters" } },
              [
                _c("el-input", {
                  attrs: {
                    size: "small",
                    placeholder: "请输入过滤器字符串集合"
                  },
                  model: {
                    value: _vm.formSys.filters,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formSys,
                        "filters",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formSys.filters"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "断言字符", prop: "predicates" } },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入断言字符串集合" },
                  model: {
                    value: _vm.formSys.predicates,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formSys,
                        "predicates",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formSys.predicates"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c("el-button", { on: { click: _vm.cancelDailog } }, [_vm._v("取消")]),
        _c(
          "el-popconfirm",
          {
            attrs: {
              title: _vm.ifSysEdit ? "确认修改此路由？" : "确认添加此路由"
            },
            on: {
              onConfirm: function($event) {
                return _vm.confirmsure(true)
              },
              onCancel: function($event) {
                return _vm.confirmsure(false)
              }
            }
          },
          [
            _c(
              "el-button",
              {
                attrs: { slot: "reference", type: "primary" },
                slot: "reference"
              },
              [_vm._v("确认")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }